module.exports = __webpack_public_path__ + "static/img/3_1.94d27dd0.jpg";